import {
  ChakraBox,
  ChakraFlex,
  ChakraText,
  CircularProgress,
  EquipUIFireflyV2Theme,
  EquipUITheme,
  ExternalLink,
  Trending,
} from '@equip.health/ui';
import { useLazyGetPatientReportLinkQuery } from '~/store/services/reports';

const TOP_LEVEL_ID = 'single-patient-report-card';

const { secondary, primary } = EquipUIFireflyV2Theme.colors;
const { h6, label: labelStyle, labelBold } = EquipUITheme.typography;

interface SinglePatientReportCardProps {
  patientId: string;
  shouldFillHeight?: boolean;
}

const SinglePatientReportCard = ({
  patientId,
  shouldFillHeight = false,
}: SinglePatientReportCardProps) => {
  const [getReportLink, { isLoading: isGetReportLinkLoading }] =
    useLazyGetPatientReportLinkQuery();

  const handleViewReport = () => {
    getReportLink(patientId).then((queryResult) => {
      if (queryResult.data) {
        window.open(queryResult.data, '_blank', 'noopener');
      }
    });
  };

  return (
    <ChakraBox
      background="secondary.5"
      borderRadius="16px"
      cursor="pointer"
      height="100%"
      id={TOP_LEVEL_ID}
      minWidth="100px"
      overflow="hidden"
      padding="16px"
      position="relative"
    >
      <ChakraFlex height="100%" justifyContent="space-between">
        <ChakraBox>
          <ChakraFlex alignItems="center" paddingBottom="4px">
            <Trending fill={secondary[50]} height="18px" weight="18px" />
            <ChakraText
              {...labelStyle}
              color="secondary.50"
              id={`${TOP_LEVEL_ID}__title`}
              paddingLeft="8px"
            >
              Report
            </ChakraText>
          </ChakraFlex>
          <ChakraText {...h6} id={`${TOP_LEVEL_ID}__subtitle`}>
            Growth chart
          </ChakraText>
        </ChakraBox>
        {isGetReportLinkLoading ? (
          <CircularProgress id={TOP_LEVEL_ID} isIndeterminate size="20px" />
        ) : (
          <ChakraFlex
            alignItems={shouldFillHeight ? 'flex-end' : 'center'}
            height={shouldFillHeight ? '100%' : 'auto'}
            id={`${TOP_LEVEL_ID}__view-report-link`}
            onClick={handleViewReport}
          >
            <ChakraText {...labelBold} color="primary.100" paddingRight="4px">
              View report
            </ChakraText>
            <ExternalLink fill={primary[100]} height="12px" width="12px" />
          </ChakraFlex>
        )}
      </ChakraFlex>
    </ChakraBox>
  );
};

export default SinglePatientReportCard;
